import React from 'react';
import style from './SignUpSection.module.scss';
import Image from '../../../../components/Image/Image';
import { RichText } from 'prismic-reactjs';
import Button, { VARIANT } from '../../../../components/Button/Button';
import { object } from 'prop-types';

const SignUpSection = ({ data }) => {
  const { primary } = data;
  const {
    description,
    heading,
    input_field_text,
    main_image,
    sub_heading,
    subscribe_button_text,
  } = primary;

  return (
    <section className={style.signUpSection}>
      <div className={style.container}>
        <div className={style.imageWrapper}>
          <Image image={main_image} />
        </div>
        <div className={style.content}>
          <div className={style.subheading}>
            <RichText render={sub_heading.richText} />
          </div>
          <div className={style.heading}>
            <RichText render={heading.richText} />
          </div>
          <div className={style.description}>
            <RichText render={description.richText} />
          </div>
          <div className={style.ButtonWrapper}>
            <div className={style.searchContainer}>
              <input
                className={style.search}
                type="email"
                placeholder={input_field_text.richText[0].text}
              />
            </div>
            <Button variant={VARIANT.SECONDARY}>
              <RichText render={subscribe_button_text.richText} />
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

SignUpSection.propTypes = {
  data: object,
};

export default SignUpSection;
